import * as types from './actionTypes';
import cycleApi from '../api/cycleApi';

export const getCyclesSuccess = cycles => ({
  cycles,
  type: types.GET_CYCLES_SUCCESS
});

export const getCycles = () =>
  dispatch =>
    cycleApi.get().then((response) => {
      dispatch(getCyclesSuccess(response.cycles));
    });



// WEBPACK FOOTER //
// ./src/actions/cycleActions.js